export const CONTINENTS = {
  'América do Sul': ['Brasil', 'Argentina', 'Chile', 'Uruguai', 'Paraguai', 'Bolívia', 'Peru', 'Colômbia', 'Equador', 'Venezuela', 'Guiana', 'Suriname', 'Gramado', 'Santiago', 'Assunção'],
  'América do Norte': ['Estados Unidos', 'Canadá', 'México'],
  'América Central/Caribe': ['Panamá', 'Costa Rica', 'Nicarágua', 'Honduras', 'Guatemala', 'Belize', 'El Salvador', 'Cuba', 'Jamaica', 'República Dominicana', 'Porto Rico', 'Bahamas', 'Trinidad e Tobago', 'Barbados', 'Punta Cana'],
  'Europa': ['Portugal', 'Espanha', 'França', 'Itália', 'Alemanha', 'Reino Unido', 'Suíça', 'Áustria', 'Países Baixos', 'Bélgica', 'Grécia', 'Turquia', 'Lisboa', 'Madrid', 'Paris', 'Roma', 'Londres', 'Frankfurt'],
  'Ásia': ['Japão', 'China', 'Coreia do Sul', 'Tailândia', 'Cingapura', 'Índia', 'Emirados Árabes', 'Tóquio', 'Seul', 'Bangkok', 'Dubai', 'Hong Kong'],
  'África': ['África do Sul', 'Egito', 'Marrocos', 'Quênia', 'Tanzânia'],
  'Oceania': ['Austrália', 'Nova Zelândia']
};

export const getContinentByDestination = (destination) => {
  for (const [continent, countries] of Object.entries(CONTINENTS)) {
    if (countries.some(country => destination.toLowerCase().includes(country.toLowerCase()))) {
      return continent;
    }
  }
  return 'Outros';
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  
  // Sempre retornar formato numérico para mobile/tablet
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};